import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListUsers from './ListUsers'
import ShowUserPage from './ShowUserPage'
import NewUserPage from './NewUserPage'
import EditUserPage from './EditUserPage'

const Users = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListUsers} />
    <Route exact path={match.url + '/new'} component={NewUserPage} />
    <Route path={match.url + '/:id/edit'} component={EditUserPage} />
    <Route path={match.url + '/:id'} component={ShowUserPage} />
  </Switch>
)

export default Users



// WEBPACK FOOTER //
// ./src/components/Users/Users.jsx